import { useNavigate } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { authConfig, completeSignIn } from '../lib/auth.ts';

/** Where Cognito sends the browser back. Exchanges the code, then goes where the user was headed. */
export function AuthCallbackPage() {
  const navigate = useNavigate();
  const ran = useRef(false); // StrictMode mounts twice; the code is single-use
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const cfg = authConfig();
    const fail = (message: string) =>
      navigate({ to: '/sign-in', search: { error: message }, replace: true });
    if (!cfg) {
      void fail('Sign-in is not configured');
      return;
    }
    completeSignIn(cfg, new URL(window.location.href))
      .then(({ returnTo }) => navigate({ to: returnTo, replace: true }))
      .catch((err: unknown) => fail(err instanceof Error ? err.message : 'Sign-in failed'));
  }, [navigate]);
  return (
    <main className="text-muted-foreground flex min-h-screen items-center justify-center gap-2 text-sm">
      <Loader2 className="size-4 animate-spin" /> Signing you in…
    </main>
  );
}
